import { useMutation } from "@tanstack/react-query";
import { resvInfApi } from "components/api/mypage";
import BookInfView from "components/view/mypage/book/inf/resv";
import { IOutletContext } from "components/view/mypage/book/layout";
import { IResvInf } from "interface/mypage";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { successControl } from "util/commAction";

export default function ResvInfPage() {
  const navigate = useNavigate();
  const { rmPdNo } = useParams();
  const { resvStat, setResvStat } = useOutletContext<IOutletContext>();
  const [resvInf, setResvInf] = useState<IResvInf>();

  //예약 상세 조회
  const resvInfMutation = useMutation({
    mutationFn: resvInfApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            setResvInf(res.data.resvInfo);
          },
        });
      }
    },
  });

  //선택된 객실정보 취소
  const handleResvCancel = () => {
    navigate("cancel");
    setResvStat("cancel");
  };

  useEffect(() => {
    if (!!rmPdNo && resvStat !== "cancel") {
      resvInfMutation.mutate(rmPdNo);
    }
  }, [resvStat, rmPdNo]);

  return (
    <>
      {resvInf && (
        <BookInfView resvInf={resvInf} handleResvCancel={handleResvCancel} />
      )}
    </>
  );
}
